/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Grounding_Occupation_WhyInputs */

const en_us2_plan_build_grounding_occupation_why = /** @type {(inputs: Plan_Build_Grounding_Occupation_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How much you move during the day adjusts training volume.`)
};

const pt_br2_plan_build_grounding_occupation_why = /** @type {(inputs: Plan_Build_Grounding_Occupation_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto você se mexe no dia ajusta o volume de treino.`)
};

const es_419_plan_build_grounding_occupation_why = /** @type {(inputs: Plan_Build_Grounding_Occupation_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cuánto te mueves durante el día ajusta el volumen de entrenamiento.`)
};

const pt_pt2_plan_build_grounding_occupation_why = /** @type {(inputs: Plan_Build_Grounding_Occupation_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O quanto te mexes durante o dia ajusta o volume de treino.`)
};

const fr_fr2_plan_build_grounding_occupation_why = /** @type {(inputs: Plan_Build_Grounding_Occupation_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton niveau d'activité dans la journée ajuste le volume d'entraînement.`)
};

const de_de2_plan_build_grounding_occupation_why = /** @type {(inputs: Plan_Build_Grounding_Occupation_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie viel du dich tagsüber bewegst, passt das Trainingsvolumen an.`)
};

const it_it2_plan_build_grounding_occupation_why = /** @type {(inputs: Plan_Build_Grounding_Occupation_WhyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quanto ti muovi durante il giorno regola il volume di allenamento.`)
};

/**
* | output |
* | --- |
* | "How much you move during the day adjusts training volume." |
*
* @param {Plan_Build_Grounding_Occupation_WhyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_grounding_occupation_why = /** @type {((inputs?: Plan_Build_Grounding_Occupation_WhyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Grounding_Occupation_WhyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_grounding_occupation_why(inputs)
	if (locale === "es-419") return es_419_plan_build_grounding_occupation_why(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_grounding_occupation_why(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_grounding_occupation_why(inputs)
	if (locale === "de-DE") return de_de2_plan_build_grounding_occupation_why(inputs)
	if (locale === "it-IT") return it_it2_plan_build_grounding_occupation_why(inputs)
	return en_us2_plan_build_grounding_occupation_why(inputs)
});
export { plan_build_grounding_occupation_why as "plan-build.grounding_occupation_why" }